/* eslint-disable max-len */
import { number, string } from 'prop-types'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'

const AppVersionIconSvg = styled.svg`
  width: ${prop('size', 36)}px;
  height: ${prop('size', 36)}px;

  .a {
    fill: ${prop('color', colorsOptions.greys['grey-100'])};
  }
`

function AppVersionIcon ({ color, hoverColor, size, ...props }) {
  return (
    <AppVersionIconSvg
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      color={color}
      hoverColor={hoverColor}
      {...props}
      viewBox="0 0 32 32"
    >
      <defs>
        <clipPath id="clip-path">
          <rect className="a" width="32" height="32" />
        </clipPath>
      </defs>
      <g id="Gruppe_7">
        <path
          className="a"
          d="M31.515,0H.485A.484.484,0,0,0,0,.485V31.515A.484.484,0,0,0,.485,32h31.03A.484.484,0,0,0,32,31.515V.485A.484.484,0,0,0,31.515,0M.97.969H31.031V4.848H.97ZM31.03,31.03H.969V5.819H31.03Z"
        />
        <path
          className="a"
          d="M42.868,3.779a.512.512,0,0,0-.14.345.489.489,0,0,0,.14.343.493.493,0,0,0,.689,0,.5.5,0,0,0,.14-.343.5.5,0,0,0-.14-.34.508.508,0,0,0-.689-.005"
          transform="translate(-14.243 -1.216)"
        />
        <path
          className="a"
          d="M39.212,3.634a.485.485,0,1,0,.485.486.487.487,0,0,0-.485-.486"
          transform="translate(-12.909 -1.211)"
        />
        <path
          className="a"
          d="M34.868,3.783a.485.485,0,0,0,.689.683.492.492,0,0,0,0-.689.5.5,0,0,0-.689.005"
          transform="translate(-11.576 -1.215)"
        />
        <path
          className="a"
          d="M10.737,20.081a2.343,2.343,0,1,0-2.343-2.343,2.346,2.346,0,0,0,2.343,2.343m0-3.717a1.374,1.374,0,1,1-1.373,1.374,1.376,1.376,0,0,1,1.373-1.374"
          transform="translate(-2.798 -5.131)"
        />
        <path
          className="a"
          d="M6.94,33.7a.485.485,0,0,0,0,.97h6.3a.485.485,0,1,0,0-.97h-.808V24.728a.484.484,0,0,0-.485-.485H6.94a.485.485,0,1,0,0,.969h.809V33.7Zm1.778-8.485h2.747V33.7H8.718Z"
          transform="translate(-2.152 -8.081)"
        />
        <path
          className="a"
          d="M22.031,20.606H33.909a.485.485,0,0,0,0-.969H22.031a.485.485,0,1,0,0,.969"
          transform="translate(-7.182 -6.546)"
        />
        <path
          className="a"
          d="M37.3,24.484H32.213a.485.485,0,0,0,0,.97H37.3a.485.485,0,0,0,0-.97"
          transform="translate(-10.576 -8.161)"
        />
        <path
          className="a"
          d="M22.031,25.454h4.12a.485.485,0,1,0,0-.97h-4.12a.485.485,0,0,0,0,.97"
          transform="translate(-7.182 -8.161)"
        />
        <path
          className="a"
          d="M22.031,30.3H33.909a.485.485,0,0,0,0-.97H22.031a.485.485,0,0,0,0,.97"
          transform="translate(-7.182 -9.778)"
        />
        <path
          className="a"
          d="M22.031,35.152h8.78a.485.485,0,0,0,0-.97h-8.78a.485.485,0,0,0,0,.97"
          transform="translate(-7.182 -11.394)"
        />
      </g>
    </AppVersionIconSvg>
  )
}

AppVersionIcon.propTypes = {
  color: string,
  hoverColor: string,
  size: number
}

export default AppVersionIcon
